// extracted by mini-css-extract-plugin
export var paginationContainer = "_93-0";